// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-account[data-v-56364890] {\n  height: 175px;\n  max-width: 175px;\n  text-align: center;\n  background-color: #179bb0;\n  color: white;\n  margin: 10px 15px;\n}\n", ""]);
// Exports
module.exports = exports;
